import { AppAction } from './app.types';

export const BOOTSTRAP = 'BOOTSTRAP';

export const bootstrap = (): AppAction => {
  return {
    type: BOOTSTRAP,
  };
};
